<template>
  <section>
    <div class="role">
      <div class="roleRight" style="border-left: 0">
        <div class="roleRight_Top">
          <el-input
              size="mini"
              clearable
              v-model="search.keyword"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchRoleList"
          ></el-input>
          <el-select size="mini" v-model="search.status" clearable placeholder="请选择">
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
          <el-button size="mini" type="primary" @click="SearchRoleList"
          >查询
          </el-button
          >
          <el-button
              size="mini"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
              row-key="roleId"
              v-loading="loading"
          >
            <el-table-column
                fixed
                label="序号"
                prop="roleId"
                type="index"
                width="80"
            >
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="币种名称" min-width="150">
            </el-table-column>
            <el-table-column prop="currency" label="标识" min-width="180">
            </el-table-column>
            <el-table-column prop="image" label="图标" min-width="180">
            </el-table-column>
            <el-table-column prop="image" label="图标位置" min-width="180">
              <template slot-scope="score">
                <el-tag type="primary" v-if="score.row.imgPost == 1">后置</el-tag>
                <el-tag type="success" v-else>前置</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="rate" label="汇率" min-width="180">
              <template slot-scope="scope">
                <el-input-number
                    size="mini"
                    type="text"
                    placeholder="输入汇率"
                    v-model="scope.row.rate"
                    :precision="4"
                    :step="0.0001"
                    @change="changeExchangeRate(scope.row)"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="150">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                    @change="changeExchangeRate(scope.row)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="默认" width="150">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.isDefault"
                    :active-value="1"
                    :inactive-value="0"
                    @change="handleSwitch(scope.row.id)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="sort" label="排序" min-width="80">
              <template slot-scope="scope">
                <el-input
                    size="mini"
                    type="text"
                    placeholder="输入参与数"
                    v-model="scope.row.sort"
                    @blur="changOrdered(scope.row.sort, scope.row.id)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" min-width="180">
              <template slot-scope="scope">
                <el-button
                    @click="handleClick('edit', scope.row)"
                    plain
                    size="small"
                >修改
                </el-button
                >
                <el-button
                    type="primary"
                    plain
                    size="small"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="public-pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pages.pageNo"
                :page-sizes="[10, 50, 100, 200, 400]"
                :page-size="pages.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑货币"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="450px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="100px"
        >

          <el-form-item
              label="货币名称："
              prop="name"
          >
            <el-input
                clearable
                placeholder="请填写名称"
                v-model="params.name"
            ></el-input>
          </el-form-item>

          <el-form-item
              label="标识："
              prop="currency"
          >
            <el-input
                clearable
                placeholder="请填写标识"
                v-model="params.currency"
            ></el-input>
          </el-form-item>
          <el-form-item
              label="币种汇率："
              prop="rate"
          >
            <el-input
                clearable
                placeholder="请填写币种汇率"
                v-model="params.rate"
            ></el-input>
          </el-form-item>
          <el-form-item
              label="图标："
              prop="image"
          >
            <el-input
                clearable
                placeholder="请填写排序"
                v-model="params.image"
            ></el-input>
          </el-form-item>
          <el-form-item label="图标位置：" prop="iconLocation">
            <el-select style="width: 100%" v-model="params.imgPost" placeholder="请选择">
              <el-option label="前置" :value="0"></el-option>
              <el-option label="后置" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
              label="排序："
              prop="sort"
          >
            <el-input
                clearable
                placeholder="请填写排序"
                v-model="params.sort"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>


export default {
  data() {
    return {
      loading: false,
      search: {},
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [{required: true, message: "请填写名称", trigger: "blur"}],
        code: [{required: true, message: "请填写标识", trigger: "blur"}],
        sourceLanguage: [{required: true, message: "请填写源语言", trigger: "blur"}],
      }, //表单验证提示
      tableData: [], //二级--角色列表，
      dialogVisible: false,
      changeTimer: false,
      pages: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
    };
  },
  created() {
    this.getLanguageList();
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
    search: {
      handler(val) {
      },
      deep: true,
    },
  },
  methods: {
    SearchRoleList() {
      this.getLanguageList()
    },
    //设置排序
    async changOrdered(num, data) {
      const {data: resData} = await this.$get(
          `/currency/sort/change/${data}`, {
            params: {
              sort: num
            }
          },
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.$message.success('操作成功')
      this.getLanguageList()
    },
    async getLanguageList() {
      this.loading = true;
      //角色列表
      const {data: res} = await this.$post(
          `/currency/page`, {...this.search, ...this.pages},
      );
      this.loading = false;
      this.tableData = res.data;
      this.total = res.page.count;
    },
    //设置汇率
    changeExchangeRate(row) {
      if (this.changeTimer) {
        clearTimeout(this.changeTimer);
      }
      this.changeTimer = setTimeout(() => {
        this.changeExchangeRateRequest(row);
      }, 500);
    },
    async changeExchangeRateRequest(row) {
      let body = {
        id: row.id,
        rate: row.rate,
        status: row.status
      }
      const {data: resData} = await this.$post("/currency/save", body, {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      this.getLanguageList();
      this.$message.success("操作成功!");
    },
    //switch状态改变 --接口 修改角色状态
    frontHandleSwitch(row) {
      if (this.changeTimer) {
        clearTimeout(this.changeTimer);
      }
      this.changeTimer = setTimeout(() => {
        this.changeExchangeRateRequest(row);
      }, 500);
    },
    //switch状态改变 --接口 修改角色状态
    handleSwitch(id) {
      this.$get(`/currency/state/change/${id}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
          this.getLanguageList()
        }
      });
    },
    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "add") {
        //编辑
        this.params = {};
      } else if (type == "edit") {
        //修改  change
        this.params = JSON.parse(JSON.stringify(row));
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          this.params.status = 1
          this.params.isDefault = 0
          const {data: resData} = await this.$post("/currency/save", this.params, {
            headers: {
              isLoading: true,
            },
          });
          if (resData.result != 200) return;
          this.getLanguageList();
          this.dialogVisible = false; //弹窗隐藏
          this.$message.success("添加成功!");
        });
      });
    },
    //删除
    async del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$get(
            `/currency/delete/${row.id}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getLanguageList();
        this.$message.success("删除成功!");
      });
    },

    //分页
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getLanguageList()
    },
    handleCurrentChange(val) {
      this.pages.pageNo = val;
      this.getLanguageList()
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  .fa-line {
    display: block;
    border-right: 1px solid #ccc;
  }

  &Left {
    padding-right: 15px;
    width: auto;

    &_List {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 20px;
    }
  }

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    padding-left: 15px;
    border-left: 1px solid #ccc;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>
